import { useClient } from '../../../react-hooks/useClient';
import { blockCategories } from './categories';

export const sioSections = async ({ editor, website }) => {
    const client = useClient();

    const domc = editor.DomComponents;
    const bm = editor.BlockManager;

    domc.addType('layout-section', {
        model: {
            defaults: {
                name: 'Layout-Section',
                tagName: 'div',
                draggable: true,
                droppable: true,
                attributes: {
                    'data-key': "",
                    'data-siotype': 'layout-section',
                },
                traits: [
                    {
                        type: 'checkbox',
                        label: 'Link with layout',
                        name: 'data-link-with-layout',
                        value: false,
                    },
                    {
                        type: 'text',
                        label: 'Key',
                        name: 'data-key',
                    },
                ],
            },
        },
    });

    const layoutSectionData = await client.get(
        'grapes-editor/corporate-design/layouts/' + website,
        false,
        {
            cache: 'no-store',
        }
    );

    const generateUniqueId = () => {
        return 'gjs-' + Math.random().toString(36).substr(2, 9);
    };

    let idMap = {};

    const updateComponentIdsAndMap = (component) => {
        if (component.attributes && component.attributes.id) {
            const oldId = component.attributes.id;
            const newId = generateUniqueId();
            idMap[oldId] = newId;
            component.attributes.id = newId;
        }
        if (component.components && Array.isArray(component.components)) {
            component.components.forEach(updateComponentIdsAndMap);
        }
    };

    const updateStylesWithNewIds = (styles, currentIdMap) => {
        if (!Array.isArray(styles)) {
            return styles;
        }

        return styles.map((styleRule) => {
            let updatedRule = { ...styleRule };

            if (updatedRule.selectors && Array.isArray(updatedRule.selectors)) {
                updatedRule.selectors = updatedRule.selectors.map(
                    (selector) => {
                        let newSelector = selector;
                        for (const oldId in currentIdMap) {
                            const newId = currentIdMap[oldId];
                            const regex = new RegExp(`#${oldId}\\b`, 'g');
                            newSelector =
                                typeof newSelector === 'object'
                                    ? newSelector
                                    : newSelector?.replace(regex, `#${newId}`);
                        }
                        return newSelector;
                    }
                );
            }
            return updatedRule;
        });
    };

    for (const [key, value] of Object.entries(layoutSectionData)) {
        const document = value?.grapesDocument;
        if(!value.hideInEditorSections){
            bm.add(key, {
                label: value.title,
                category: { ...blockCategories.prebuiltSections },
                draggable: true,
                droppable: true,
                content: () => {
                    const uniqueClass = `custom-block-${value.key || key}`;

                    const componentsArray =
                        document.pages[0].frames[0].component.components;

                    if (!Array.isArray(componentsArray)) {
                        console.error('Invalid component format:', componentsArray);
                        return;
                    }

                    idMap = {};

                    const clonedComponents = JSON.parse(
                        JSON.stringify(componentsArray)
                    );

                    clonedComponents.forEach(updateComponentIdsAndMap);

                    const clonedStyles = JSON.parse(
                        JSON.stringify(document.styles)
                    );
                    const updatedStyles = updateStylesWithNewIds(
                        clonedStyles,
                        idMap
                    );

                    return {
                        type: 'layout-section',
                        attributes: {
                            class: uniqueClass,
                            'data-key': value?.key || key,
                            'data-siotype': 'layout-section',
                        },
                        components: clonedComponents,
                        styles: updatedStyles,
                    };
                },
                media: `<svg xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" id="page-break-3" data-name="Line Color" class="icon line-color"><path id="secondary" d="M21,12H17M3,12H7m6,0H11" style="fill: none; stroke: rgb(44, 169, 188); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/><path id="primary" d="M5,8V5L7,3H18a1,1,0,0,1,1,1V8" style="fill: none; stroke: rgb(255, 255, 255); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/><path id="primary-2" data-name="primary" d="M5,16v4a1,1,0,0,0,1,1H18a1,1,0,0,0,1-1V16" style="fill: none; stroke: rgb(255, 255, 255); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/><polygon id="primary-3" data-name="primary" points="5 5 7 5 7 3 5 5" style="fill: none; stroke: rgb(255, 255, 255); stroke-linecap: round; stroke-linejoin: round; stroke-width: 2;"/></svg>`,
            });
        }
    }
};
